import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import { ref } from 'vue'
import { sanitizeTitle } from '@@/bits/landside_helper'

export interface LandsideNavigation {
  url: string
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideFooterSection',
  props: {
    title: null,
    navigationItems: null,
    xDivider: { type: Boolean, default: true }
  },
  setup(__props: any) {



const isOpen = ref(false)
const { isSmallerThanDesktop } = storeToRefs(useWindowSizeStore())

return { __sfc: true,isOpen, isSmallerThanDesktop, OzBaseButton, OzDivider, OzDividerColorScheme, OzIcon, sanitizeTitle }
}

})